import { render, staticRenderFns } from "./GameContainer.vue?vue&type=template&id=aa971bf0&scoped=true&"
import script from "./GameContainer.vue?vue&type=script&lang=js&"
export * from "./GameContainer.vue?vue&type=script&lang=js&"
import style0 from "./GameContainer.vue?vue&type=style&index=0&id=aa971bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa971bf0",
  null
  
)

export default component.exports